import classNames from 'classnames';
import { ForwardedRef, forwardRef } from 'react';
import Icon from '../Icons/Icon';
import styles from './Checkbox.module.css';
import { CheckboxProps } from './Checkbox.types';

const Checkbox = forwardRef<HTMLInputElement, CheckboxProps>(
  ({ checked, label, id, disabled, className, ...props }, ref: ForwardedRef<HTMLInputElement>) => (
    <ul className={styles.container}>
      <li>
        <input
          {...props}
          type="checkbox"
          checked={checked}
          ref={ref}
          id={id}
          aria-checked={checked}
          aria-disabled={disabled ? 'true' : 'false'}
          disabled={disabled}
          className={classNames(styles.checkbox, { [className!]: className !== undefined })}
        />
        <Icon iconName="Check" />
        <label
          htmlFor={id}
          className={classNames(styles.label, { [styles.disabled]: disabled, [styles.hidden]: label === '' })}
        >
          {label}
        </label>
      </li>
    </ul>
  ),
);

Checkbox.displayName = 'Checkbox';

export default Checkbox;
